import ApiService from "../../common/apiService";
import { getData } from "../../common/dataHelper";
import { NOTE_TYPES } from "../types";
const state = {
    notes: [],
};

const getters = {
    [NOTE_TYPES.GET_NOTES](state) {
        return state.notes;
    },
};

const actions = {
    async [NOTE_TYPES.FETCH_NOTES]({ commit, rootState }) {
        const slideId = getData(rootState, "slides.slide.id");
        if (!slideId) {
            return;
        }
        const response = await ApiService.query(
            `academy/slides/${slideId}/notes`
        );
        const notes = getData(response, "data.notes");
        if (notes) {
            commit(NOTE_TYPES.SET_NOTES, notes);
        }
        return response;
    },

    async [NOTE_TYPES.CREATE_NOTE]({ rootState, state }, { note }) {
        const slideId = getData(rootState, "slides.slide.id");
        if (!slideId) {
            return;
        }
        note.slide = slideId;
        const response = await ApiService.post(
            `academy/slides/${slideId}/notes`,
            note
        );
        const newNote = getData(response, "data.note");
        if (newNote) {
            state.notes.push(newNote);
        }

        return response;
    },

    async [NOTE_TYPES.UPDATE_NOTE]({ rootState }, { note }) {
        const slideId = getData(rootState, "slides.slide.id");
        if (!slideId) {
            return;
        }
        const response = await ApiService.put(
            `academy/slides/${slideId}/notes/${note.id}`,
            note
        );
        if (getData(response, "status") == 200) {
            const index = state.notes.findIndex(
                (stateNote) => stateNote.id == note.id
            );

            if (index != -1) {
                state.notes[index] = note;
            }
        }

        return response;
    },

    async [NOTE_TYPES.DELETE_NOTE]({ rootState, state }, { note }) {
        const slideId = getData(rootState, "slides.slide.id");
        if (!slideId) {
            return;
        }
        const response = await ApiService.delete(
            `academy/slides/${slideId}/notes/${note.id}`
        );
        if (getData(response, "status") === 204) {
            state.notes = state.notes.filter(
                (stateNote) => stateNote.id != note.id
            );
        }
        return response;
    },
};

const mutations = {
    [NOTE_TYPES.SET_NOTES](state, array) {
        state.notes = array;
    },
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters,
};
